import HTTP from '@/utils/http'

class UsercenterModel extends HTTP {
  /**
   * @description Lily-学习端 PC登录
   * @param {Object} data
   * @see http://yapi.lilyenglish.cn/project/57/interface/api/8551
   */
  login(data) {
    return this.post({
      url: '/usercenter/user/pc/phone/login',
      data
    })
  }

  /**
   * @description 用户登出
   * @param {Object} data
   * @see http://yapi.lilyenglish.cn/project/57/interface/api/5863
   */
  logout(userId) {
    return this.post({
      url: `/usercenter/user/logout?userId=${userId}`
    })
  }

  /**
   * @description web短信验证码（需要先获取图形验证码）
   * @param {Object} params
   * @see http://yapi.lilyenglish.cn/project/57/interface/api/1527
   */
  getVerifyCode(params) {
    return this.get({
      url: '/usercenter/common/verifyCode',
      params
    })
  }

  /**
   * @description 获取tokencode
   * @param {*} params 
   * @returns 
   */
  getTokenCode(params){
    return this.get({
      url:'/usercenter/user/init/token/code',
      headers:{
        token:params.token
      }
    })
  }

  /**
   * @description app忘记密码功能-获取短信验证码
   * @param {Object} params
   * @see http://yapi.dayuan1997.com/project/11/interface/api/4356
   */
  getVerifyCodeForget(params) {
    return this.get({
      url: '/usercenter/common/forget/pw/verifycode',
      params
    })
  }

  /**
   * @description app忘记密码功能-修改密码
   * @param {Object} data
   * @see http://yapi.dayuan1997.com/project/11/interface/api/4361
   */
  modifyPassword(data) {
    return this.post({
      url: '/usercenter/common/forget/password',
      data
    })
  }
}

// 存储用户KEY
UsercenterModel.USER_INFO_KEY = 'USER'

export default UsercenterModel